const t = {
  user: (e, s) => [
    "user-account",
    `level-${e}`,
    s ? `relationship-username-${s}` : void 0
  ].filter(Boolean),
  userAll: ["user-account"],
  facilitiesStates: (e) => [
    "account-facilities-states",
    `${e ? "abbreviation" : "name"}`
  ],
  allStates: (e) => [
    "all-states",
    `${e ? "abbreviation" : "name"}`
  ],
  accountFacilities: (e) => [
    "account-facilities",
    `by-state-${e.toLocaleLowerCase()}`
  ],
  facilities: ["account-facilities"],
  scFacilities: ["sc-facilities"],
  facilityByFeature: (e) => ["account-facilities", e],
  facilityDetail: (e) => ["sc-facilities", "detail", e],
  sso: ["sso-partner-links"],
  userRelationships: ["user-relationships"],
  accountsRelationTypes: ["accounts-relation-types"],
  imsImage: (e) => ["ims-image", e],
  upcomingVisits: ["upcoming-visits"],
  encounters: (e) => [
    "account-encounters",
    `results-per-page-${e.resultsPerPage}`,
    `sort-direction-${e.sortDirection}`,
    `sort-type-${e.sortType}`,
    `pageNumber-${e.pageNumber}`,
    e.startAdmitDate ? `start-admit-date-${e.startAdmitDate}` : ""
  ],
  labEvents: (e) => [
    "clinical-records-lab-events",
    `results-per-page-${e.resultsPerPage}`,
    `sort-direction-${e.sortDirection}`,
    `sort-type-${e.sortType}`,
    `pageNumber-${e.pageNumber}`,
    e.startDate ? `start-date-${e.startDate}` : ""
  ],
  // healthRecordProblemsPaginated: (params: UseProblemQueryParams): Array<string> => [
  //   'health-record-problems',
  //   `results-per-page-${params.resultsPerPage}`,
  //   `sort-direction-${params.sortDirection}`,
  //   `sort-type-${params.sortType}`,
  //   `pageNumber-${params.pageNumber}`,
  // ],
  employmentStatuses: ["employment-statuses"],
  healthRecordMedications: ["health-record-medications"],
  patientsFeatureAdCampaign: ["patients-feature-ad-campaign"],
  // patientEducationArticleList: (payload: ArticleListPayload): Array<string> => [
  //   'patient-education-article-list',
  //   `age-${payload.age}`,
  //   `gender-${payload.gender}`,
  //   `code-${payload.code}`,
  //   `code-system-oid-${payload.codeSystemOid}`,
  //   `topic-name-${payload.topicName}`,
  //   `topic-type-${payload.topicType}`,
  // ],
  // patientEducationArticleContent: (params: UseGetArticleContentQueryParams): Array<string> => [
  //   'patient-education-article-content',
  //   `article-key-${params.articleKey}`,
  //   `topic-type-${params.topicType}`,
  // ],
  healthRecordArticleContent: ["health-record-article-content"],
  messages: ["messages"],
  messageThread: (e) => [...t.messages, "thread", e],
  unreadMessagesCount: () => [...t.messages, "unread"],
  messagesFilterType: (e) => [
    ...t.messages,
    e
  ],
  activityLog: (e) => [
    "activity-log",
    `results-per-page-${e.resultsPerPage}`,
    `sort-direction-${e.sortDirection}`,
    `sort-by-${e.sortBy}`,
    `pageIndex-${e.pageIndex}`,
    `timezone-offset-${e.timeZoneOffset}`
  ],
  scActivityLog: (e) => [
    "activity-log",
    `results-per-page-${e.PageLimit}`,
    `sort-direction-${e.SortOrder}`,
    `sort-by-${e.SortCriteria}`,
    `pageIndex-${e.PageIndex}`,
    `timezone-offset-${e.TimeZoneOffset}`
  ]
}, i = 9e5;
export {
  i as S,
  t as q
};
